import React, { useEffect, useState } from 'react'
import { CCard, CCardBody } from '@coreui/react-pro'
import EmailQuotaService from 'src/service/EmailQuotaService'
import './GameNotification.css'

const formatNumber = (value) => Number(value || 0).toLocaleString()

// getQuotaDetails returns quota (total purchased), emails_sent and quota_left. The old widget
// row showed quota_left twice and hard-coded every progress bar to 75%.
const EmailQuotaPanel = () => {
  const [quota, setQuota] = useState({})

  useEffect(() => {
    EmailQuotaService.getQuotaDetails().then((res) => {
      if (res.status === 200) {
        setQuota(res.data || {})
      }
    })
  }, [])

  const total = Number(quota?.quota || 0)
  const sent = Number(quota?.emails_sent || 0)
  const left = Number(quota?.quota_left || 0)
  const usedPercent = total > 0 ? Math.min(Math.round((sent / total) * 100), 100) : 0

  return (
    <CCard className="gn-panel mb-4">
      <CCardBody>
        <div className="gn-quota-row">
          <div className="gn-quota-tiles">
            <div>
              <span className="gn-quota-label">Email quota</span>
              <span className="gn-quota-value">{formatNumber(total)}</span>
            </div>
            <div>
              <span className="gn-quota-label">Emails sent</span>
              <span className="gn-quota-value gn-quota-value--sent">{formatNumber(sent)}</span>
            </div>
            <div>
              <span className="gn-quota-label">Remaining</span>
              <span className="gn-quota-value">{formatNumber(left)}</span>
            </div>
          </div>
          <p className="gn-quota-note">
            {total > 0 ? (
              <>
                <strong>{usedPercent}%</strong> of your quota used
              </>
            ) : (
              'No email quota purchased yet.'
            )}
          </p>
        </div>
        <div
          className="gn-meter"
          role="img"
          aria-label={`${formatNumber(sent)} of ${formatNumber(total)} emails used`}
        >
          <span
            className={usedPercent >= 100 ? 'is-full' : undefined}
            style={{ width: `${usedPercent}%` }}
          />
        </div>
      </CCardBody>
    </CCard>
  )
}

export default EmailQuotaPanel
